/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Team_Settings_Server_WriteInputs */



/**
* | output |
* | --- |
* | "Change the server and bot settings" |
*
* @param {Perm_Team_Settings_Server_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_team_settings_server_write = /** @type {((inputs?: Perm_Team_Settings_Server_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Team_Settings_Server_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменять настройки сервера и бота")
	return /** @type {LocalizedString} */ ("Change the server and bot settings")
});